.container > *:first-child {
    padding-bottom: 2px;
}
